import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/ai-course-finder/ai-course-finder.component').then(
        (m) => m.AiCourseFinderComponent
      ),
  },
  { path: '**', redirectTo: '' },
];
